import { BarChart3, LayoutDashboard } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  DASHBOARD_TABS,
  DASHBOARD_TAB_LABELS,
  dashboardTabFromKey,
  type DashboardTab,
} from './dashboardTabState'

export interface DashboardTabsProps {
  activeTab: DashboardTab
  onChange: (tab: DashboardTab) => void
}

const TAB_ICONS: Record<DashboardTab, typeof LayoutDashboard> = {
  summary: LayoutDashboard,
  analysis: BarChart3,
}

/** Dos vistas: el primer vistazo y el análisis detallado cuando se pide. */
export function DashboardTabs({ activeTab, onChange }: DashboardTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Vistas del panel"
      className="flex w-full gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-slate-50 p-1 sm:w-fit"
    >
      {DASHBOARD_TABS.map((tab) => {
        const selected = tab === activeTab
        const Icon = TAB_ICONS[tab]

        return (
          <button
            key={tab}
            id={`dashboard-tab-${tab}`}
            type="button"
            role="tab"
            aria-selected={selected}
            aria-controls={`dashboard-panel-${tab}`}
            tabIndex={selected ? 0 : -1}
            onClick={() => onChange(tab)}
            onKeyDown={(event) => {
              const next = dashboardTabFromKey(activeTab, event.key)
              if (!next) return
              event.preventDefault()
              onChange(next)
              document.getElementById(`dashboard-tab-${next}`)?.focus()
            }}
            className={cn(
              'flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand sm:flex-none',
              selected
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-500 hover:text-slate-800'
            )}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
            {DASHBOARD_TAB_LABELS[tab]}
          </button>
        )
      })}
    </div>
  )
}
